// Perguntas prontas do Ale, com respostas ESTÁTICAS (client-side).
// Vantagens: funcionam sem IA (Fase 1), são instantâneas, corretas e gratuitas,
// e ajudam o público idoso que tem dificuldade de digitar.
// Estas respostas espelham a base de conhecimento oficial (frontend/docs/BOT_ALE_PLANEJAMENTO.md).

export const QUICK_REPLIES = [
  {
    id: 'diferenca-planos',
    label: 'Qual a diferença entre os planos?',
    answer:
      'Em todos os planos o atendimento e os serviços são exatamente os mesmos. O que muda de um plano para o outro é a URNA (o caixão) e o valor.\n\n' +
      '• Essencial: urna simples.\n' +
      '• Clássico: urna com visor.\n' +
      '• Semi-Luxo, Luxo, Super-Luxo e Presidencial: urnas mais completas, com valores diferentes (o Luxo é o mais escolhido).\n\n' +
      'A mensalidade aumenta conforme a idade, e o valor exato aparece no resumo da tela depois que você informa a data de nascimento.',
  },
  {
    id: 'responsavel-financeiro',
    label: 'O que é responsável financeiro?',
    answer:
      'O responsável financeiro é quem contrata e paga o plano.\n\n' +
      '• Se o plano é para você, você é o titular (quem tem a cobertura) e também o responsável financeiro.\n' +
      '• Se você está contratando para outra pessoa, você é o responsável financeiro e informa os dados do titular (a pessoa que terá a cobertura) à parte.\n\n' +
      'Nesse caso, o CPF do responsável financeiro precisa ser diferente do CPF do titular.',
  },
  {
    id: 'titular-dependente',
    label: 'O que é titular e dependente?',
    answer:
      'O titular é o beneficiário, ou seja, a pessoa que tem a cobertura do plano.\n\n' +
      'O dependente é alguém incluído além do titular. O valor do dependente é fixo por faixa de idade.',
  },
  {
    id: 'pet',
    label: 'Posso incluir meu pet?',
    answer:
      'Pode sim! Todos os planos permitem incluir pets.\n\n' +
      '• Nos planos comuns, o pet é um adicional opcional, e você escolhe o serviço para ele (Cremação Coletiva, Sepultamento ou Cremação Individual).\n' +
      '• Também existe o plano exclusivo PET, que é só para o animal.\n\n' +
      'O valor do serviço do pet não muda conforme o plano da pessoa.',
  },
  {
    id: 'carencia',
    label: 'Como funciona a carência?',
    answer:
      'A carência é um período inicial de espera após a contratação. Cada plano tem uma cobertura em dinheiro garantida durante esse período. Nos planos de pet, a carência é contada conforme a idade do animal.\n\n' +
      'Se quiser saber os detalhes da carência de um plano específico, posso te encaminhar para um atendente.',
  },
  {
    id: 'atendente',
    label: 'Falar com um atendente',
    answer: null, // tratado como encaminhamento direto ao WhatsApp
    toWhatsapp: true,
    whatsappMessage:
      'Olá! Eu estava no Ecommerce da Santa Casa Copacabana e gostaria de falar com um atendente, por favor.',
  },
];
